import { Client, ScenarioSettings } from "src/types";
import { getTaxRate, yearRange } from "../../utils";
import MainChart from ".././Charts/MainChart";
import Header from "../Report/Header";
import { useScenario } from "src/hooks/useScenario";
import { useUser } from "src/hooks/useUser";

interface MapChartProps {
  settings: ScenarioSettings;
  client: Client;
  print?: boolean;
}

const ByIncomeChart = ({ settings, client, print }: MapChartProps) => {
  const incomes = settings.incomes.filter((inc) => inc.enabled);
  const { user } = useUser();
  const startYear = new Date().getFullYear();
  const { scenario } = useScenario();
  const groupedIncomesByTaxType = incomes.reduce((acc, income) => {
    const key = income.type;
    if (!acc[key]) acc[key] = [];
    acc[key].push(income);
    return acc;
  }, {} as any);

  return (
    <div className={`bg-white ${!print && "pb-5"} ${print && "mr-5"}`}>
      <Header client={client as any} scenario={settings} page="Incomes" />
      <MainChart
        years={yearRange(startYear, startYear + settings.maxYearsShown - 1)}
        spending={false}
        initialHeight={print ? 660 : 550}
        longevityFlag={!!user?.info?.longevityFlag}
        people={client.people}
        lineData={[]}
        taxes={[]}
        stability={!!user?.info?.stabilityRatioFlag}
        needsFlag={false}
        stackedData={[
          ...Object.keys(groupedIncomesByTaxType).map((key) => {
            return {
              name: key
                .split("-")
                .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
                .join(" "),
              stable: true,
              values: yearRange(
                startYear,
                startYear + settings.maxYearsShown - 1,
              ).map((year) => {
                const income = groupedIncomesByTaxType[key]
                  .map(
                    (income: any) => scenario[year]?.incomes[income.id].amount,
                  )
                  .filter((t: any) => typeof t === "number")
                  .reduce((a: any, b: any) => a + b, 0);
                const taxRate = getTaxRate(user, settings, year);
                return income * (1 - taxRate);
              }),
            };
          }),
        ]}
      />
    </div>
  );
};

export default ByIncomeChart;
